// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IIdNameDto } from './IIdNameDto';
import {
    IIdNameDtoFromJSON,
    IIdNameDtoFromJSONTyped,
    IIdNameDtoToJSON,
    IIdNameDtoToJSONTyped,
} from './IIdNameDto';
import type { INamePropertyDto } from './INamePropertyDto';
import {
    INamePropertyDtoFromJSON,
    INamePropertyDtoFromJSONTyped,
    INamePropertyDtoToJSON,
    INamePropertyDtoToJSONTyped,
} from './INamePropertyDto';
import type { IHealthPlanTypePropertyDto } from './IHealthPlanTypePropertyDto';
import {
    IHealthPlanTypePropertyDtoFromJSON,
    IHealthPlanTypePropertyDtoFromJSONTyped,
    IHealthPlanTypePropertyDtoToJSON,
    IHealthPlanTypePropertyDtoToJSONTyped,
} from './IHealthPlanTypePropertyDto';

/**
 * 
 * @export
 * @interface IHealthPlanBaseDto
 */
export interface IHealthPlanBaseDto {
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanBaseDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanBaseDto
     */
    parent_id?: number;
    /**
     * 
     * @type {IHealthPlanTypePropertyDto}
     * @memberof IHealthPlanBaseDto
     */
    health_plan_types?: IHealthPlanTypePropertyDto;
    /**
     * 
     * @type {INamePropertyDto}
     * @memberof IHealthPlanBaseDto
     */
    name?: INamePropertyDto;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanBaseDto
     */
    plan_status?: string;
    /**
     * 
     * @type {number}
     * @memberof IHealthPlanBaseDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanBaseDto
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof IHealthPlanBaseDto
     */
    notes?: string;
    /**
     * 
     * @type {IIdNameDto}
     * @memberof IHealthPlanBaseDto
     */
    plan_year?: IIdNameDto;
}

/**
 * Check if a given object implements the IHealthPlanBaseDto interface.
 */
export function instanceOfIHealthPlanBaseDto(value: object): value is IHealthPlanBaseDto {
    return true;
}

export function IHealthPlanBaseDtoFromJSON(json: any): IHealthPlanBaseDto {
    return IHealthPlanBaseDtoFromJSONTyped(json, false);
}

export function IHealthPlanBaseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IHealthPlanBaseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'parent_id': json['parent_id'] == null ? undefined : json['parent_id'],
        'health_plan_types': json['health_plan_types'] == null ? undefined : IHealthPlanTypePropertyDtoFromJSON(json['health_plan_types']),
        'name': json['name'] == null ? undefined : INamePropertyDtoFromJSON(json['name']),
        'plan_status': json['plan_status'] == null ? undefined : json['plan_status'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'plan_year': json['plan_year'] == null ? undefined : IIdNameDtoFromJSON(json['plan_year']),
    };
}

export function IHealthPlanBaseDtoToJSON(json: any): IHealthPlanBaseDto {
    return IHealthPlanBaseDtoToJSONTyped(json, false);
}

export function IHealthPlanBaseDtoToJSONTyped(value?: IHealthPlanBaseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'parent_id': value['parent_id'],
        'health_plan_types': IHealthPlanTypePropertyDtoToJSON(value['health_plan_types']),
        'name': INamePropertyDtoToJSON(value['name']),
        'plan_status': value['plan_status'],
        'organization_id': value['organization_id'],
        'summary': value['summary'],
        'notes': value['notes'],
        'plan_year': IIdNameDtoToJSON(value['plan_year']),
    };
}

